export interface RegisterDefaultParameterCollectionRequest {
  configBranchCode: string
  searchType: string
  traderCode: string
  acceptType: string
  buyDepartmentCode: string
  donorCode: string
  collectionType: string
  budgetYear: number | string
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
}

export function RegisterDefaultParameterCollectionRequestToJSON(
  value: RegisterDefaultParameterCollectionRequest
): any {
  return {
    config_branch_code:
      value.configBranchCode !== '' ? value.configBranchCode : undefined,
    search_type: value.searchType !== '' ? value.searchType : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    buy_department_code:
      value.buyDepartmentCode !== '' ? value.buyDepartmentCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    budget_year: value.budgetYear !== '' ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined
  }
}
